import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useDocuments } from 'contexts/documents'
import { fullSelectionActions } from '../'
import { cls } from 'utilities/dom'
import { Container, CloseButton, BulkActions } from './s'
import { ButtOnDark } from 'components/button'
import { X, DownloadCloud as Download, Trash2 as Remove } from 'styled-icons/feather'
import { TextEdit, UserEdit } from 'components/feather'

const DocumentsBulkBottomPanel = ({ act, progress, dismiss }) => {
    const {
        selection,
        getEditableSelection
    } = useDocuments()

    const getDisabled = action => {
        const selectionToOperateOn = fullSelectionActions.includes(action) ?
            selection :
            getEditableSelection()

        return !selectionToOperateOn.length || progress.busy
    }

    const loading = which => (progress.which === which && progress.busy) ?
        { className: 'loading' } :
        null

    return (
        <Container>
            <CloseButton
                onClick={dismiss}
                icon={<X size={24} />}>
                <FormattedMessage
                    id="selected_count"
                    defaultMessage="{count, plural, =0 {None selected} =1 {1 selected} other {# selected}}"
                    values={{ count: selection.length }} />
            </CloseButton>
            <BulkActions>
                <ButtOnDark
                    onClick={() => act('name')}
                    icon={TextEdit}
                    className={cls([
                        'medium',
                        'narrow',
                        !!loading('name') && 'loading'
                    ])}
                    disabled={getDisabled('name')}>
                    <FormattedMessage
                        id="noun_name"
                        defaultMessage="Name" />
                </ButtOnDark>
                <ButtOnDark
                    onClick={() => act('concerns')}
                    icon={UserEdit}
                    className={cls([
                        'medium',
                        'narrow',
                        !!loading('concerns') && 'loading'
                    ])}
                    disabled={getDisabled('concerns')}>
                    <FormattedMessage
                        id="document_label_regarding"
                        defaultMessage="Regarding" />
                </ButtOnDark>
                <ButtOnDark
                    onClick={() => act('category')}
                    icon={TextEdit}
                    className={cls([
                        'medium',
                        'narrow',
                        !!loading('category') && 'loading'
                    ])}
                    disabled={getDisabled('category')}>
                    <FormattedMessage
                        id="noun_category"
                        defaultMessage="Category" />
                </ButtOnDark>
                <ButtOnDark
                    onClick={() => act('access')}
                    icon={UserEdit}
                    className={cls([
                        'medium',
                        'narrow',
                        !!loading('access') && 'loading'
                    ])}
                    disabled={getDisabled('access')}>
                    <FormattedMessage
                        id="noun_access"
                        defaultMessage="Access" />
                </ButtOnDark>
                <ButtOnDark
                    onClick={() => act('download')}
                    icon={Download}
                    className={cls(
                        'medium',
                        'narrow',
                        !!loading('download') && 'loading'
                    )}
                    disabled={getDisabled('download')}>
                    <FormattedMessage
                        id="action_download"
                        defaultMessage="Download" />
                </ButtOnDark>
                <ButtOnDark
                    onClick={() => act('remove')}
                    icon={Remove}
                    className={cls(
                        'destructive',
                        'medium',
                        'narrow',
                        !!loading('remove') && 'loading'
                    )}
                    disabled={getDisabled('remove')}>
                    <FormattedMessage
                        id="action_delete"
                        defaultMessage="Delete" />
                </ButtOnDark>
            </BulkActions>
        </Container>
    )
}

export default DocumentsBulkBottomPanel